import { blackAccent, offWhite } from "../ColorPallette/ColorPallette";

export const mobileBreakpoint = 1000;

export const universalBackground = blackAccent;

export const backgroundsDark = blackAccent;

export const backgroundsLight = offWhite;

export const textDark = offWhite;

export const textLight = blackAccent;